import React, { Component } from "react";
import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import { ValidationUtils } from "../Sidebar/Common";
import TableRuleTriggerWizard from "./TableRuleTriggerWizard";

import LoadingOverlay from "./LoadingOverlay";
export default class Table_rule_triggers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      // Enhanced state for cross-table rule execution
      tableColumns: [],
      selectedTable: "",
      emailTemplates: [],
      selectedEmailTemplate: "",
      templateVariables: [],
      parameterMappings: [],
      conditionsBuilder: {
        conditions: [
          {
            field: "",
            operator: "=",
            value: "",
            dataType: "text",
            logicalOperator: "AND",
          },
        ],
      },
      operators: {
        text: ["=", "!=", "contains", "not_contains", "is_null", "is_not_null"],
        number: ["=", "!=", ">", "<", ">=", "<="],
        date: ["=", "!=", ">", "<", ">=", "<="],
        boolean: ["=", "!="],
      },
      tableClms: [
        {
          name: "S.NO",

          selector: (row, i) => row.table_rule_triggers_Id,
          sortable: true,
          cell: (row) => <span>{row.table_rule_triggers_Id}</span>,
        },
        {
          name: "Table Name",
          selector: (row, i) => row.table_name,
          sortable: true,
          cell: (row) => <span>{row.table_name}</span>,
        },
        {
          name: "Rule Id",
          selector: (row, i) => row.rule_id,

          sortable: true,

          cell: (row) => <span>{row.rule_id}</span>,
        },

        {
          name: "Rule Name",

          selector: (row, i) => row.rule_name,

          sortable: true,

          cell: (row) => <span>{row.rule_name}</span>,
        },

        {
          name: "Priority",

          selector: (row, i) => row.priority,

          sortable: true,

          cell: (row) => <span>{row.priority}</span>,
        },

        {
          name: "Is Active",

          selector: (row, i) => row.is_active,

          sortable: true,

          cell: (row) => <span>{row.is_active}</span>,
        },

        {
          name: "Conditions",

          selector: (row, i) => row.conditions,

          sortable: true,

          cell: (row) => <span>{row.conditions}</span>,
        },

        {
          name: "Trigger Event",

          selector: (row, i) => row.trigger_event,

          sortable: true,

          cell: (row) => <span>{row.trigger_event}</span>,
        },

        {
          name: "Parameter Mappings",
          selector: (row, i) => row.parameter_mappings,
          sortable: true,
          cell: (row) => <span>{row.parameter_mappings}</span>,
        },
        {
          name: "Email Template Id",
          selector: (row, i) => row.email_template_id,
          sortable: true,
          cell: (row) => <span>{row.email_template_id}</span>,
        },
        {
          name: "Cross Table Config",
          selector: (row, i) => row.cross_table_config,
          sortable: true,
          cell: (row) => <span>{row.cross_table_config}</span>,
        },
        {
          name: "Enhanced Conditions",
          selector: (row, i) => row.enhanced_conditions,
          sortable: true,
          cell: (row) => <span>{row.enhanced_conditions}</span>,
        },
        {
          name: "Execution Mode",
          selector: (row, i) => row.execution_mode,
          sortable: true,
          cell: (row) => <span>{row.execution_mode}</span>,
        },
        {
          name: "Last Executed At",
          selector: (row, i) => row.last_executed_at,
          sortable: true,
          cell: (row) => <span>{row.last_executed_at}</span>,
        },
        {
          name: "Execution Count",
          selector: (row, i) => row.execution_count,
          sortable: true,
          cell: (row) => <span>{row.execution_count}</span>,
        },
        {
          name: "Success Count",
          selector: (row, i) => row.success_count,
          sortable: true,
          cell: (row) => <span>{row.success_count}</span>,
        },
        {
          name: "Failure Count",
          selector: (row, i) => row.failure_count,
          sortable: true,
          cell: (row) => <span>{row.failure_count}</span>,
        },
        {
          name: "Avg Execution Time Ms",
          selector: (row, i) => row.avg_execution_time_ms,
          sortable: true,
          cell: (row) => <span>{row.avg_execution_time_ms}</span>,
        },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.Table_rule_triggerseditHandler(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],

      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      table_rule_triggers_Id: "",
      table_name: "",
      rule_id: "",
      rule_name: "",
      priority: "",
      yes_no: [],
      is_active: "",
      conditions: "",
      trigger_event_type_master: [],
      trigger_event: "",
      parameter_mappings: "",
      email_template_id: "",
      cross_table_config: "",
      enhanced_conditions: "",
      execution_mode: "",
      last_executed_at: "",
      execution_count: "",
      success_count: "",
      failure_count: "",
      avg_execution_time_ms: "",
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic

  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;

    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions

    switch (inputType.toLowerCase()) {
      case "text":
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(
            value,

            parseInt(validationOptions.maxLength),

            fieldDisplayName
          );
        } else {
          validationResult = { isValid: true, message: "" };
        }

        break;

      case "mail":

      case "email":
        validationResult = ValidationUtils.validateEmail(value);

        break;

      case "telephone":

      case "phone":
        validationResult = ValidationUtils.validatePhone(value);

        break;

      case "number":
        validationResult = ValidationUtils.validateNumber(
          value,

          fieldDisplayName
        );

        break;

      case "dob_child":
        validationResult = ValidationUtils.validateDOBMinAge(value);

        break;

      case "dob_adult":
        validationResult = ValidationUtils.validateDOBAdult(value);

        break;

      case "pan":
        validationResult = ValidationUtils.validatePAN(value);

        break;

      case "aadhaar":
        validationResult = ValidationUtils.validateAadhaar(value);

        break;

      case "password":
        if (value.length < 6) {
          validationResult = {
            isValid: false,

            message: "Password must be at least 6 characters long",
          };
        }

        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation

    if (
      validationOptions?.isRequired &&
      (!value || value.toString().trim() === "")
    ) {
      validationResult = ValidationUtils.validateRequired(
        value,

        fieldDisplayName
      );
    }

    const errors = { ...this.state.errors };

    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });

    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation

  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,

      touched: { ...this.state.touched, [fieldName]: true },
    });

    // Only validate if field has been touched

    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation

  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true },
    });

    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields

  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation

    // Auto-generated required field validation

    const requiredFields = ["table_name", "rule_name"];

    for (const field of requiredFields) {
      if (!this.state[field] || this.state[field].toString().trim() === "") {
        return false;
      }
    }

    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission

  validateAllFields = () => {
    const fieldConfigs = [
      {
        fieldName: "table_name",

        inputType: "Text",

        displayName: "Table Name",

        validationOptions: { isRequired: true, maxLength: 100 },
      },

      {
        fieldName: "rule_id",

        inputType: "Number",

        displayName: "Rule Id",

        validationOptions: { isRequired: false, maxLength: 50 },
      },

      {
        fieldName: "rule_name",

        inputType: "Text",

        displayName: "Rule Name",

        validationOptions: { isRequired: true, maxLength: 255 },
      },

      {
        fieldName: "priority",

        inputType: "Number",

        displayName: "Priority",

        validationOptions: { isRequired: false, maxLength: 50 },
      },

      {
        fieldName: "is_active",

        inputType: "Select",

        displayName: "Is Active",

        validationOptions: { isRequired: false, maxLength: 50 },
      },

      {
        fieldName: "conditions",

        inputType: "Text",

        displayName: "Conditions",

        validationOptions: { isRequired: false, maxLength: 50 },
      },

      {
        fieldName: "trigger_event",

        inputType: "Select",

        displayName: "Trigger Event",

        validationOptions: { isRequired: false, maxLength: 50 },
      },
    ];

    fieldConfigs.forEach((config) => {
      const value = this.state[config.fieldName];

      this.validateField(config.fieldName, value, config);
    });

    const touched = {};

    fieldConfigs.forEach((config) => {
      touched[config.fieldName] = true;
    });

    this.setState({ touched });
  };

  // offcanvas Open

  handleOffcanvasShow = () => {
    this.setState({
      show: true,

      errors: {},

      touched: {},

      table_name: "",

      rule_id: "",

      rule_name: "",

      priority: "",
      is_active: "",

      conditions: "",
      trigger_event: "",
    });
  };

  // Offcanvas close button

  handleOffcanvasClose = () => {
    this.setState({
      show: false,

      isEditing: false,

      errors: {},

      touched: {},

      table_name: "",

      rule_id: "",

      rule_name: "",

      priority: "",
      is_active: "",

      conditions: "",
      trigger_event: "",
    });
  };

  // Enhanced toast notifications

  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);

        break;

      case "error":
        toast.error(msg);

        break;

      case "warning":
        toast.warn(msg);

        break;

      default:
        toast.info(msg);
    }
  };

  Table_rule_triggerseditHandler = (row) => {
    this.setState({
      isEditing: true,

      show: true,

      table_rule_triggers_Id: row.table_rule_triggers_Id,

      table_name: row.table_name,

      rule_id: row.rule_id,

      rule_name: row.rule_name,

      priority: row.priority,
      is_active: row.is_active,

      conditions: row.conditions,
      trigger_event: row.trigger_event,

      parameter_mappings: row.parameter_mappings,
      email_template_id: row.email_template_id,
      cross_table_config: row.cross_table_config,
      enhanced_conditions: row.enhanced_conditions,
      execution_mode: row.execution_mode,
      last_executed_at: row.last_executed_at,
      execution_count: row.execution_count,
      success_count: row.success_count,
      failure_count: row.failure_count,
      avg_execution_time_ms: row.avg_execution_time_ms, //***editstate

      errors: {},

      touched: {},
    });
  };

  Table_rule_triggersfetchHandler = () => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Table_rule_triggers/list", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })

      .catch((error) => {
        console.error("Fetch error:", error);

        this.showToast("Failed to load data", "error");
      });
  };

  Table_rule_triggerssubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission

    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");

      return;
    }

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("table_name", this.state.table_name);

    formData.append("rule_id", this.state.rule_id);

    formData.append("rule_name", this.state.rule_name);

    formData.append("priority", this.state.priority);

    formData.append("is_active", this.state.is_active);

    formData.append("conditions", this.state.conditions);

    formData.append("trigger_event", this.state.trigger_event);

    // Enhanced rule configuration data

    const ruleConfig = this.buildRuleConfiguration();

    formData.append("enhanced_conditions", ruleConfig.conditions);

    formData.append(
      "email_template_config",
      JSON.stringify(ruleConfig.emailTemplate)
    );

    formData.append("parameter_mappings", this.state.parameter_mappings);

    formData.append("email_template_id", this.state.email_template_id);

    formData.append("cross_table_config", this.state.cross_table_config);

    formData.append("enhanced_conditions", this.state.enhanced_conditions);

    formData.append("execution_mode", this.state.execution_mode);

    formData.append("last_executed_at", this.state.last_executed_at);

    formData.append("execution_count", this.state.execution_count);

    formData.append("success_count", this.state.success_count);

    formData.append("failure_count", this.state.failure_count);

    formData.append("avg_execution_time_ms", this.state.avg_execution_time_ms);
    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Table_rule_triggers/add", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.Table_rule_triggersfetchHandler();

          this.handleOffcanvasClose();

          this.setState({
            table_name: "",

            rule_id: "",

            rule_name: "",

            priority: "",
            is_active: "",

            conditions: "",
            trigger_event: "",
          });
        }
      
        this.setState({ loading: false });})

      .catch((error) => {
        console.error("Submit error:", error);

        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  };

  Table_rule_triggersupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission

    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");

      return;
    }

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append(
      "table_rule_triggers_Id",

      this.state.table_rule_triggers_Id
    );

    formData.append("table_name", this.state.table_name);

    formData.append("rule_id", this.state.rule_id);

    formData.append("rule_name", this.state.rule_name);

    formData.append("priority", this.state.priority);

    formData.append("is_active", this.state.is_active);

    formData.append("conditions", this.state.conditions);

    formData.append("trigger_event", this.state.trigger_event);

    // Enhanced rule configuration data

    const ruleConfig = this.buildRuleConfiguration();

    formData.append("enhanced_conditions", ruleConfig.conditions);

    formData.append(
      "email_template_config",
      JSON.stringify(ruleConfig.emailTemplate)
    );

    formData.append("parameter_mappings", this.state.parameter_mappings);

    formData.append("email_template_id", this.state.email_template_id);

    formData.append("cross_table_config", this.state.cross_table_config);

    formData.append("enhanced_conditions", this.state.enhanced_conditions);

    formData.append("execution_mode", this.state.execution_mode);

    formData.append("last_executed_at", this.state.last_executed_at);

    formData.append("execution_count", this.state.execution_count);

    formData.append("success_count", this.state.success_count);

    formData.append("failure_count", this.state.failure_count);

    formData.append("avg_execution_time_ms", this.state.avg_execution_time_ms);
    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Table_rule_triggers/update", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.Table_rule_triggersfetchHandler();

          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})

      .catch((error) => {
        console.error("Update error:", error);

        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  };

  // Enhanced methods for cross-table rule execution

  // Fetch table columns when table is selected

  fetchTableColumns = (tableName) => {
    if (!tableName) return;

    const formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("tableName", tableName);

    fetch(configData.api_url + "C_Table_rule_triggers/getTableColumns", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({
            tableColumns: data.columns,

            selectedTable: tableName,
          });
        }
      })

      .catch((error) => {
        console.error("Error fetching table columns:", error);

        this.showToast("Failed to fetch table columns", "error");
      });
  };

  // Fetch email templates

  fetchEmailTemplates = () => {
    const formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Emailtemplates/list", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({ emailTemplates: data.list });
        }
      })

      .catch((error) => {
        console.error("Error fetching email templates:", error);
      });
  };

  // Get template variables when template is selected

  fetchTemplateVariables = (templateId) => {
    const formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("templateId", templateId);

    fetch(configData.api_url + "EmailSender/getTemplateVariables", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({
            templateVariables: data.data.variables,

            selectedEmailTemplate: templateId,
          });

          this.initializeParameterMappings(data.data.variables);
        }
      })

      .catch((error) => {
        console.error("Error fetching template variables:", error);

        this.showToast("Failed to fetch template variables", "error");
      });
  };

  // Initialize parameter mappings for template variables

  initializeParameterMappings = (variables) => {
    const mappings = variables.map((variable) => ({
      templateVariable: variable.name,

      sourceType: "current_table",

      sourceTable: this.state.table_name,

      sourceField: "",

      lookupTable: "",

      lookupJoinField: "",

      lookupFetchField: "",
    }));

    this.setState({ parameterMappings: mappings });
  };

  // Add new condition row

  addCondition = () => {
    const newConditions = [...this.state.conditionsBuilder.conditions];

    newConditions.push({
      field: "",

      operator: "=",

      value: "",

      dataType: "text",

      logicalOperator: "AND",
    });

    this.setState({
      conditionsBuilder: {
        ...this.state.conditionsBuilder,

        conditions: newConditions,
      },
    });
  };

  // Remove condition row

  removeCondition = (index) => {
    const newConditions = [...this.state.conditionsBuilder.conditions];

    newConditions.splice(index, 1);

    this.setState({
      conditionsBuilder: {
        ...this.state.conditionsBuilder,

        conditions: newConditions,
      },
    });
  };

  // Update condition

  updateCondition = (index, field, value) => {
    const newConditions = [...this.state.conditionsBuilder.conditions];

    newConditions[index][field] = value;

    // Auto-detect data type based on field selection

    if (field === "field" && value) {
      const selectedColumn = this.state.tableColumns.find(
        (col) => col.name === value
      );

      if (selectedColumn) {
        newConditions[index].dataType = selectedColumn.type;

        newConditions[index].operator =
          this.state.operators[selectedColumn.type][0];
      }
    }

    this.setState({
      conditionsBuilder: {
        ...this.state.conditionsBuilder,

        conditions: newConditions,
      },
    });
  };

  // Update parameter mapping

  updateParameterMapping = (index, field, value) => {
    const newMappings = [...this.state.parameterMappings];

    newMappings[index][field] = value;

    // If source type changes, reset related fields

    if (field === "sourceType") {
      newMappings[index].sourceTable =
        value === "current_table" ? this.state.table_name : "";

      newMappings[index].sourceField = "";

      newMappings[index].lookupTable = "";

      newMappings[index].lookupJoinField = "";

      newMappings[index].lookupFetchField = "";
    }

    this.setState({ parameterMappings: newMappings });
  };

  // Build final configuration for backend

  buildRuleConfiguration = () => {
    return {
      conditions: JSON.stringify(this.state.conditionsBuilder.conditions),

      emailTemplate: {
        templateId: this.state.selectedEmailTemplate,

        parameterMappings: this.state.parameterMappings,
      },
    };
  };

  // Enhanced table name change handler

  handleTableNameChange = (value) => {
    this.setState({ table_name: value });

    if (value) {
      this.fetchTableColumns(value);
    }
  };

  componentDidMount() {
    this.Table_rule_triggersfetchHandler();

    this.yes_nofetchHandler();

    this.trigger_event_type_masterfetchHandler();

    this.fetchEmailTemplates();

    //***componentDidMount
  }

  handletable_nameChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ table_name: fieldValue });

    // Fetch table columns when table name is entered

    if (fieldValue) {
      this.fetchTableColumns(fieldValue);
    }
  };

  handlerule_idChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ rule_id: fieldValue });
  };

  handlerule_nameChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ rule_name: fieldValue });
  };

  handlepriorityChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ priority: fieldValue });
  };

  handleis_activeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ is_active: fieldValue });
  };

  yes_nofetchHandler = () => {
    fetch(configData.api_url + "C_Yes_no/list", {
      // Enter your IP address here

      method: "POST",

      mode: "cors",

      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({ yes_no: data.list });
        }
      });
  };

  handleconditionsChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ conditions: fieldValue });
  };

  handletrigger_eventChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ trigger_event: fieldValue });
  };

  trigger_event_type_masterfetchHandler = () => {
    fetch(configData.api_url + "C_Trigger_event_type_master/list", {
      // Enter your IP address here

      method: "POST",

      mode: "cors",

      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({ trigger_event_type_master: data.list });
        }
      });
  };

  handleparameter_mappingsChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ parameter_mappings: fieldValue });
  };
  handleemail_template_idChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ email_template_id: fieldValue });
  };
  handlecross_table_configChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ cross_table_config: fieldValue });
  };
  handleenhanced_conditionsChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ enhanced_conditions: fieldValue });
  };
  handleexecution_modeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ execution_mode: fieldValue });
  };
  handlelast_executed_atChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ last_executed_at: fieldValue });
  };
  handleexecution_countChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ execution_count: fieldValue });
  };
  handlesuccess_countChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ success_count: fieldValue });
  };
  handlefailure_countChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ failure_count: fieldValue });
  };
  handleavg_execution_time_msChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ avg_execution_time_ms: fieldValue });
  }; //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];

    const index = oldData.index;

    data[index] = newData;

    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (
      !window.confirm(
        `Are you sure you want to delete this table_rule_triggers?`
      )
    ) {
      return;
    }

    var formData = new FormData();

    formData.append("table_rule_triggers_Id", row.table_rule_triggers_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Table_rule_triggers/delete", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.Table_rule_triggersfetchHandler();
        }
      
        this.setState({ loading: false });})

      .catch((error) => {
        console.error("Delete error:", error);

        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();

    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });

    this.setState({ filteredData });
  };

  // Helper method to render error message

  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;

    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>

          {errors[fieldName]}
        </div>
      );
    }

    return null;
  };

  // Helper method to test rule execution

  testRuleExecution = (tableName, triggerEvent) => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("tableName", tableName);

    formData.append("triggerEvent", triggerEvent);

    formData.append(
      "testData",
      JSON.stringify({
        test_field: "test_value",

        created_at: new Date().toISOString(),
      })
    );

    formData.append("recordId", "1");

    fetch(configData.api_url + "C_Table_rule_triggers/testRuleExecution", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.showToast(`Rule test completed for ${tableName}`, "success");

          console.log("Rule execution test result:", data.execution_result);
        } else {
          this.showToast(`Rule test failed: ${data.message}`, "error");
        }
      })

      .catch((error) => {
        console.error("Test error:", error);

        this.showToast("Failed to test rule execution", "error");
      });
  };

  // Helper method to get rules for a specific table

  getRulesForTable = (tableName) => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("tableName", tableName);

    fetch(configData.api_url + "C_Table_rule_triggers/getRulesForTable", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.showToast(
            `Found ${data.rules.length} rules for ${tableName}`,
            "success"
          );

          console.log("Rules for table:", data.rules);
        } else {
          this.showToast(`Failed to get rules: ${data.message}`, "error");
        }
      })

      .catch((error) => {
        console.error("Get rules error:", error);

        this.showToast("Failed to get rules for table", "error");
      });
  };

  // Helper method to get execution statistics

  getExecutionStats = (tableName = null) => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    if (tableName) {
      formData.append("tableName", tableName);
    }

    fetch(configData.api_url + "C_Table_rule_triggers/getRuleExecutionStats", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.showToast("Execution statistics retrieved", "success");

          console.log("Execution statistics:", data.statistics);
        } else {
          this.showToast(`Failed to get statistics: ${data.message}`, "error");
        }
      })

      .catch((error) => {
        console.error("Stats error:", error);

        this.showToast("Failed to get execution statistics", "error");
      });
  };

  // Helper method to toggle rule status

  toggleRuleStatus = (ruleTriggerId) => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("table_rule_triggers_Id", ruleTriggerId);

    fetch(configData.api_url + "C_Table_rule_triggers/toggleRuleStatus", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.showToast(
            `Rule status updated to ${data.new_status}`,
            "success"
          );

          this.Table_rule_triggersfetchHandler(); // Refresh the data
        } else {
          this.showToast(`Failed to toggle status: ${data.message}`, "error");
        }
      })

      .catch((error) => {
        console.error("Toggle status error:", error);

        this.showToast("Failed to toggle rule status", "error");
      });
  };

  // Helper method to create rule condition JSON

  createRuleCondition = (field, operator, value) => {
    return JSON.stringify([
      {
        field: field,

        operator: operator,

        value: value,
      },
    ]);
  };

  // Helper method to validate rule condition JSON

  validateRuleCondition = (conditionJson) => {
    try {
      const conditions = JSON.parse(conditionJson);

      if (!Array.isArray(conditions)) {
        return { valid: false, message: "Conditions must be an array" };
      }

      for (const condition of conditions) {
        if (
          !condition.field ||
          !condition.operator ||
          condition.value === undefined
        ) {
          return {
            valid: false,
            message: "Each condition must have field, operator, and value",
          };
        }
      }

      return { valid: true, message: "Valid condition format" };
    } catch (error) {
      return { valid: false, message: "Invalid JSON format" };
    }
  };

  // Auto-generated form field renderer based on inputType and validation options

  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } =
      fieldConfig;

    const value = this.state[fieldName] || "";

    const hasError =
      this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case "dob_child":

      case "dob_adult":

      case "date":
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );

        break;

      case "telephone":

      case "phone":
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );

        break;

      case "mail":

      case "email":
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );

        break;

      case "password":
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );

        break;

      case "number":
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );

        break;

      case "pan":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,

                e.target.value.toUpperCase(),

                fieldConfig
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );

        break;

      case "aadhaar":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,

                e.target.value.replace(/\D/g, ""),

                fieldConfig
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );

        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}

            {validationOptions?.isRequired && (
              <span className="text-danger">*</span>
            )}
          </Form.Label>
        </Col>

        <Col lg="8" md="8">
          {inputElement}

          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,

        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,

        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Table Rule Triggers
                      </h3>
                    </div>

                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary"
                        style={{
                          float: "right",
                          marginRight: "10px",
                        }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      <TableRuleTriggerWizard />

                      {/* Enhanced Add Offcanvas */}

                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "850px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Add Table Rule Triggers
                          </Offcanvas.Title>
                        </Offcanvas.Header>

                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            {/* Error Summary */}

                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>
                                  Please fix the following errors:
                                </strong>

                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(
                                    ([field, error]) => (
                                      <li key={field}>{error}</li>
                                    )
                                  )}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Table Name
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handletable_nameChange}
                                        className="form-control"
                                        name="table_name"
                                        value={this.state.table_name}
                                        required="required"
                                        placeholder="Enter Table Name"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.table_name}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Rule Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handlerule_idChange}
                                        className="form-control"
                                        name="rule_id"
                                        value={this.state.rule_id}
                                        required="required"
                                        placeholder="Enter Rule Id"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.rule_id}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Rule Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlerule_nameChange}
                                        className="form-control"
                                        name="rule_name"
                                        value={this.state.rule_name}
                                        required="required"
                                        placeholder="Enter Rule Name"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.rule_name}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Priority
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handlepriorityChange}
                                        className="form-control"
                                        name="priority"
                                        value={this.state.priority}
                                        required="required"
                                        placeholder="Enter Priority"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.priority}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Is Active
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select
                                        className="form-select"
                                        name="is_active"
                                        value={this.state.is_active}
                                        onChange={this.handleis_activeChange}
                                      >
                                        <option defaultValue>
                                          {" "}
                                          Select Is Active{" "}
                                        </option>
                                        {this.state.yes_no.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.value}
                                            >
                                              {" "}
                                              {api.value}{" "}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.is_active}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Conditions
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleconditionsChange}
                                        className="form-control"
                                        name="conditions"
                                        value={this.state.conditions}
                                        required="required"
                                        placeholder="Enter Conditions"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.conditions}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Trigger Event
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select
                                        className="form-select"
                                        name="trigger_event"
                                        value={this.state.trigger_event}
                                        onChange={
                                          this.handletrigger_eventChange
                                        }
                                      >
                                        <option defaultValue>
                                          {" "}
                                          Select Trigger Event{" "}
                                        </option>
                                        {this.state.trigger_event_type_master.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.insert}
                                            >
                                              {" "}
                                              {api.insert}{" "}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.trigger_event}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Parameter Mappings
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleparameter_mappingsChange
                                        }
                                        className="form-control"
                                        name="parameter_mappings"
                                        value={this.state.parameter_mappings}
                                        required="required"
                                        placeholder="Enter Parameter Mappings"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Email Template Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={
                                          this.handleemail_template_idChange
                                        }
                                        className="form-control"
                                        name="email_template_id"
                                        value={this.state.email_template_id}
                                        required="required"
                                        placeholder="Enter Email Template Id"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Cross Table Config
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlecross_table_configChange
                                        }
                                        className="form-control"
                                        name="cross_table_config"
                                        value={this.state.cross_table_config}
                                        required="required"
                                        placeholder="Enter Cross Table Config"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Enhanced Conditions
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleenhanced_conditionsChange
                                        }
                                        className="form-control"
                                        name="enhanced_conditions"
                                        value={this.state.enhanced_conditions}
                                        required="required"
                                        placeholder="Enter Enhanced Conditions"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Execution Mode
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={
                                          this.handleexecution_modeChange
                                        }
                                        className="form-control"
                                        name="execution_mode"
                                        value={this.state.execution_mode}
                                        required="required"
                                        placeholder="Enter Execution Mode"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Last Executed At
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="date"
                                        onChange={
                                          this.handlelast_executed_atChange
                                        }
                                        className="form-control"
                                        name="last_executed_at"
                                        value={this.state.last_executed_at}
                                        required="required"
                                        placeholder="Enter Last Executed At"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Execution Count
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={
                                          this.handleexecution_countChange
                                        }
                                        className="form-control"
                                        name="execution_count"
                                        value={this.state.execution_count}
                                        required="required"
                                        placeholder="Enter Execution Count"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Success Count
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={
                                          this.handlesuccess_countChange
                                        }
                                        className="form-control"
                                        name="success_count"
                                        value={this.state.success_count}
                                        required="required"
                                        placeholder="Enter Success Count"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Failure Count
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={
                                          this.handlefailure_countChange
                                        }
                                        className="form-control"
                                        name="failure_count"
                                        value={this.state.failure_count}
                                        required="required"
                                        placeholder="Enter Failure Count"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Avg Execution Time MS
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={
                                          this.handleavg_execution_time_msChange
                                        }
                                        className="form-control"
                                        name="avg_execution_time_ms"
                                        value={this.state.avg_execution_time_ms}
                                        required="required"
                                        placeholder="Enter Avg Execution Time MS"
                                      />
                                    </Col>
                                  </Row>
                                  <br />

                                  {/* Enhanced Value-Based Conditions Builder */}

                                  <Row className="mb-3">
                                    <Col lg="12">
                                      <Form.Label>
                                        <strong>Value-Based Conditions</strong>
                                      </Form.Label>

                                      <div
                                        className="border rounded p-3"
                                        style={{ backgroundColor: "#f8f9fa" }}
                                      >
                                        {this.state.conditionsBuilder.conditions.map(
                                          (condition, index) => (
                                            <Row
                                              key={index}
                                              className="mb-2 align-items-end"
                                            >
                                              <Col md={3}>
                                                <Form.Label>Field</Form.Label>

                                                <Form.Select
                                                  value={condition.field}
                                                  onChange={(e) =>
                                                    this.updateCondition(
                                                      index,
                                                      "field",
                                                      e.target.value
                                                    )
                                                  }
                                                >
                                                  <option value="">
                                                    Select Field
                                                  </option>

                                                  {this.state.tableColumns.map(
                                                    (col) => (
                                                      <option
                                                        key={col.name}
                                                        value={col.name}
                                                      >
                                                        {col.name} ({col.type})
                                                      </option>
                                                    )
                                                  )}
                                                </Form.Select>
                                              </Col>

                                              <Col md={2}>
                                                <Form.Label>
                                                  Operator
                                                </Form.Label>

                                                <Form.Select
                                                  value={condition.operator}
                                                  onChange={(e) =>
                                                    this.updateCondition(
                                                      index,
                                                      "operator",
                                                      e.target.value
                                                    )
                                                  }
                                                >
                                                  {this.state.operators[
                                                    condition.dataType
                                                  ]?.map((op) => (
                                                    <option key={op} value={op}>
                                                      {op}
                                                    </option>
                                                  ))}
                                                </Form.Select>
                                              </Col>

                                              <Col md={3}>
                                                <Form.Label>Value</Form.Label>

                                                <Form.Control
                                                  type={
                                                    condition.dataType ===
                                                      "number"
                                                      ? "number"
                                                      : "text"
                                                  }
                                                  value={condition.value}
                                                  onChange={(e) =>
                                                    this.updateCondition(
                                                      index,
                                                      "value",
                                                      e.target.value
                                                    )
                                                  }
                                                  placeholder="Enter value or {{parameter}}"
                                                />
                                              </Col>

                                              <Col md={2}>
                                                <Form.Label>Logic</Form.Label>

                                                <Form.Select
                                                  value={
                                                    condition.logicalOperator
                                                  }
                                                  onChange={(e) =>
                                                    this.updateCondition(
                                                      index,
                                                      "logicalOperator",
                                                      e.target.value
                                                    )
                                                  }
                                                >
                                                  <option value="AND">
                                                    AND
                                                  </option>

                                                  <option value="OR">OR</option>
                                                </Form.Select>
                                              </Col>

                                              <Col md={2}>
                                                <Button
                                                  variant="outline-danger"
                                                  size="sm"
                                                  onClick={() =>
                                                    this.removeCondition(index)
                                                  }
                                                  disabled={
                                                    this.state.conditionsBuilder
                                                      .conditions.length === 1
                                                  }
                                                >
                                                  Remove
                                                </Button>
                                              </Col>
                                            </Row>
                                          )
                                        )}

                                        <Button
                                          variant="outline-primary"
                                          size="sm"
                                          onClick={this.addCondition}
                                        >
                                          Add Condition
                                        </Button>
                                      </div>
                                    </Col>
                                  </Row>

                                  {/* Email Template Configuration */}

                                  <Row className="mb-3">
                                    <Col lg="12">
                                      <Form.Label>
                                        <strong>
                                          Email Template Configuration
                                        </strong>
                                      </Form.Label>

                                      <div
                                        className="border rounded p-3"
                                        style={{ backgroundColor: "#f8f9fa" }}
                                      >
                                        {/* Template Selection */}

                                        <Row className="mb-3">
                                          <Col md={6}>
                                            <Form.Label>
                                              Select Email Template
                                            </Form.Label>

                                            <Form.Select
                                              value={
                                                this.state.selectedEmailTemplate
                                              }
                                              onChange={(e) => {
                                                this.setState({
                                                  selectedEmailTemplate:
                                                    e.target.value,
                                                });

                                                if (e.target.value) {
                                                  this.fetchTemplateVariables(
                                                    e.target.value
                                                  );
                                                }
                                              }}
                                            >
                                              <option value="">
                                                Select Template
                                              </option>

                                              {this.state.emailTemplates.map(
                                                (template) => (
                                                  <option
                                                    key={
                                                      template.emailtemplates_Id
                                                    }
                                                    value={
                                                      template.emailtemplates_Id
                                                    }
                                                  >
                                                    {template.name}
                                                  </option>
                                                )
                                              )}
                                            </Form.Select>
                                          </Col>
                                        </Row>

                                        {/* Parameter Mappings */}

                                        {this.state.templateVariables.length >
                                          0 && (
                                            <div>
                                              <h6>Template Variable Mappings</h6>

                                              {this.state.parameterMappings.map(
                                                (mapping, index) => (
                                                  <Row
                                                    key={index}
                                                    className="mb-2 p-2 border rounded"
                                                  >
                                                    <Col md={2}>
                                                      <Form.Label>
                                                        Variable
                                                      </Form.Label>

                                                      <Form.Control
                                                        value={
                                                          mapping.templateVariable
                                                        }
                                                        readOnly
                                                        className="bg-light"
                                                      />
                                                    </Col>

                                                    <Col md={2}>
                                                      <Form.Label>
                                                        Source Type
                                                      </Form.Label>

                                                      <Form.Select
                                                        value={mapping.sourceType}
                                                        onChange={(e) =>
                                                          this.updateParameterMapping(
                                                            index,
                                                            "sourceType",
                                                            e.target.value
                                                          )
                                                        }
                                                      >
                                                        <option value="current_table">
                                                          Current Table
                                                        </option>

                                                        <option value="lookup_table">
                                                          Lookup Table
                                                        </option>
                                                      </Form.Select>
                                                    </Col>

                                                    {mapping.sourceType ===
                                                      "current_table" ? (
                                                      <Col md={3}>
                                                        <Form.Label>
                                                          Field from{" "}
                                                          {this.state.table_name}
                                                        </Form.Label>

                                                        <Form.Select
                                                          value={
                                                            mapping.sourceField
                                                          }
                                                          onChange={(e) =>
                                                            this.updateParameterMapping(
                                                              index,
                                                              "sourceField",
                                                              e.target.value
                                                            )
                                                          }
                                                        >
                                                          <option value="">
                                                            Select Field
                                                          </option>

                                                          {this.state.tableColumns.map(
                                                            (col) => (
                                                              <option
                                                                key={col.name}
                                                                value={col.name}
                                                              >
                                                                {col.name}
                                                              </option>
                                                            )
                                                          )}
                                                        </Form.Select>
                                                      </Col>
                                                    ) : (
                                                      <>
                                                        <Col md={2}>
                                                          <Form.Label>
                                                            Lookup Table
                                                          </Form.Label>

                                                          <Form.Control
                                                            value={
                                                              mapping.lookupTable
                                                            }
                                                            onChange={(e) =>
                                                              this.updateParameterMapping(
                                                                index,
                                                                "lookupTable",
                                                                e.target.value
                                                              )
                                                            }
                                                            placeholder="e.g., customers"
                                                          />
                                                        </Col>

                                                        <Col md={2}>
                                                          <Form.Label>
                                                            Join Field (Current)
                                                          </Form.Label>

                                                          <Form.Select
                                                            value={
                                                              mapping.lookupJoinField
                                                            }
                                                            onChange={(e) =>
                                                              this.updateParameterMapping(
                                                                index,
                                                                "lookupJoinField",
                                                                e.target.value
                                                              )
                                                            }
                                                          >
                                                            <option value="">
                                                              Select Field
                                                            </option>

                                                            {this.state.tableColumns.map(
                                                              (col) => (
                                                                <option
                                                                  key={col.name}
                                                                  value={col.name}
                                                                >
                                                                  {col.name}
                                                                </option>
                                                              )
                                                            )}
                                                          </Form.Select>
                                                        </Col>

                                                        <Col md={2}>
                                                          <Form.Label>
                                                            Fetch Field (Lookup)
                                                          </Form.Label>

                                                          <Form.Control
                                                            value={
                                                              mapping.lookupFetchField
                                                            }
                                                            onChange={(e) =>
                                                              this.updateParameterMapping(
                                                                index,
                                                                "lookupFetchField",
                                                                e.target.value
                                                              )
                                                            }
                                                            placeholder="e.g., email, name"
                                                          />
                                                        </Col>
                                                      </>
                                                    )}
                                                  </Row>
                                                )
                                              )}
                                            </div>
                                          )}
                                      </div>
                                    </Col>
                                  </Row>

                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>

                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={
                                    this.Table_rule_triggerssubmitHandler
                                  }
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}

                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "850px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              Add Table Rule Triggers
                            </Offcanvas.Title>
                          </Offcanvas.Header>

                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              {/* Error Summary */}

                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>
                                    Please fix the following errors:
                                  </strong>

                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(
                                      ([field, error]) => (
                                        <li key={field}>{error}</li>
                                      )
                                    )}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Table Name
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handletable_nameChange}
                                          className="form-control"
                                          name="table_name"
                                          value={this.state.table_name}
                                          required="required"
                                          placeholder="Enter Table Name"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.table_name}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Rule Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handlerule_idChange}
                                          className="form-control"
                                          name="rule_id"
                                          value={this.state.rule_id}
                                          required="required"
                                          placeholder="Enter Rule Id"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.rule_id}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Rule Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlerule_nameChange}
                                          className="form-control"
                                          name="rule_name"
                                          value={this.state.rule_name}
                                          required="required"
                                          placeholder="Enter Rule Name"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.rule_name}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Priority
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handlepriorityChange}
                                          className="form-control"
                                          name="priority"
                                          value={this.state.priority}
                                          required="required"
                                          placeholder="Enter Priority"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.priority}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Is Active
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select
                                          className="form-select"
                                          name="is_active"
                                          value={this.state.is_active}
                                          onChange={this.handleis_activeChange}
                                        >
                                          <option defaultValue>
                                            {" "}
                                            Select Is Active{" "}
                                          </option>
                                          {this.state.yes_no.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.value}
                                              >
                                                {" "}
                                                {api.value}{" "}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.is_active}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Conditions
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleconditionsChange}
                                          className="form-control"
                                          name="conditions"
                                          value={this.state.conditions}
                                          required="required"
                                          placeholder="Enter Conditions"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.conditions}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Trigger Event
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select
                                          className="form-select"
                                          name="trigger_event"
                                          value={this.state.trigger_event}
                                          onChange={
                                            this.handletrigger_eventChange
                                          }
                                        >
                                          <option defaultValue>
                                            {" "}
                                            Select Trigger Event{" "}
                                          </option>
                                          {this.state.trigger_event_type_master.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.insert}
                                              >
                                                {" "}
                                                {api.insert}{" "}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.trigger_event}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Parameter Mappings
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleparameter_mappingsChange
                                          }
                                          className="form-control"
                                          name="parameter_mappings"
                                          value={this.state.parameter_mappings}
                                          required="required"
                                          placeholder="Enter Parameter Mappings"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Email Template Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handleemail_template_idChange
                                          }
                                          className="form-control"
                                          name="email_template_id"
                                          value={this.state.email_template_id}
                                          required="required"
                                          placeholder="Enter Email Template Id"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Cross Table Config
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlecross_table_configChange
                                          }
                                          className="form-control"
                                          name="cross_table_config"
                                          value={this.state.cross_table_config}
                                          required="required"
                                          placeholder="Enter Cross Table Config"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Enhanced Conditions
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleenhanced_conditionsChange
                                          }
                                          className="form-control"
                                          name="enhanced_conditions"
                                          value={this.state.enhanced_conditions}
                                          required="required"
                                          placeholder="Enter Enhanced Conditions"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Execution Mode
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handleexecution_modeChange
                                          }
                                          className="form-control"
                                          name="execution_mode"
                                          value={this.state.execution_mode}
                                          required="required"
                                          placeholder="Enter Execution Mode"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Last Executed At
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={
                                            this.handlelast_executed_atChange
                                          }
                                          className="form-control"
                                          name="last_executed_at"
                                          value={this.state.last_executed_at}
                                          required="required"
                                          placeholder="Enter Last Executed At"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Execution Count
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handleexecution_countChange
                                          }
                                          className="form-control"
                                          name="execution_count"
                                          value={this.state.execution_count}
                                          required="required"
                                          placeholder="Enter Execution Count"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Success Count
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handlesuccess_countChange
                                          }
                                          className="form-control"
                                          name="success_count"
                                          value={this.state.success_count}
                                          required="required"
                                          placeholder="Enter Success Count"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Failure Count
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handlefailure_countChange
                                          }
                                          className="form-control"
                                          name="failure_count"
                                          value={this.state.failure_count}
                                          required="required"
                                          placeholder="Enter Failure Count"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Avg Execution Time MS
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this
                                              .handleavg_execution_time_msChange
                                          }
                                          className="form-control"
                                          name="avg_execution_time_ms"
                                          value={
                                            this.state.avg_execution_time_ms
                                          }
                                          required="required"
                                          placeholder="Enter Avg Execution Time MS"
                                        />
                                      </Col>
                                    </Row>
                                    <br />

                                    {/* Enhanced Value-Based Conditions Builder */}

                                    <Row className="mb-3">
                                      <Col lg="12">
                                        <Form.Label>
                                          <strong>
                                            Value-Based Conditions
                                          </strong>
                                        </Form.Label>

                                        <div
                                          className="border rounded p-3"
                                          style={{ backgroundColor: "#f8f9fa" }}
                                        >
                                          {this.state.conditionsBuilder.conditions.map(
                                            (condition, index) => (
                                              <Row
                                                key={index}
                                                className="mb-2 align-items-end"
                                              >
                                                <Col md={3}>
                                                  <Form.Label>Field</Form.Label>

                                                  <Form.Select
                                                    value={condition.field}
                                                    onChange={(e) =>
                                                      this.updateCondition(
                                                        index,
                                                        "field",
                                                        e.target.value
                                                      )
                                                    }
                                                  >
                                                    <option value="">
                                                      Select Field
                                                    </option>

                                                    {this.state.tableColumns.map(
                                                      (col) => (
                                                        <option
                                                          key={col.name}
                                                          value={col.name}
                                                        >
                                                          {col.name} ({col.type}
                                                          )
                                                        </option>
                                                      )
                                                    )}
                                                  </Form.Select>
                                                </Col>

                                                <Col md={2}>
                                                  <Form.Label>
                                                    Operator
                                                  </Form.Label>

                                                  <Form.Select
                                                    value={condition.operator}
                                                    onChange={(e) =>
                                                      this.updateCondition(
                                                        index,
                                                        "operator",
                                                        e.target.value
                                                      )
                                                    }
                                                  >
                                                    {this.state.operators[
                                                      condition.dataType
                                                    ]?.map((op) => (
                                                      <option
                                                        key={op}
                                                        value={op}
                                                      >
                                                        {op}
                                                      </option>
                                                    ))}
                                                  </Form.Select>
                                                </Col>

                                                <Col md={3}>
                                                  <Form.Label>Value</Form.Label>

                                                  <Form.Control
                                                    type={
                                                      condition.dataType ===
                                                        "number"
                                                        ? "number"
                                                        : "text"
                                                    }
                                                    value={condition.value}
                                                    onChange={(e) =>
                                                      this.updateCondition(
                                                        index,
                                                        "value",
                                                        e.target.value
                                                      )
                                                    }
                                                    placeholder="Enter value or {{parameter}}"
                                                  />
                                                </Col>

                                                <Col md={2}>
                                                  <Form.Label>Logic</Form.Label>

                                                  <Form.Select
                                                    value={
                                                      condition.logicalOperator
                                                    }
                                                    onChange={(e) =>
                                                      this.updateCondition(
                                                        index,
                                                        "logicalOperator",
                                                        e.target.value
                                                      )
                                                    }
                                                  >
                                                    <option value="AND">
                                                      AND
                                                    </option>

                                                    <option value="OR">
                                                      OR
                                                    </option>
                                                  </Form.Select>
                                                </Col>

                                                <Col md={2}>
                                                  <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    onClick={() =>
                                                      this.removeCondition(
                                                        index
                                                      )
                                                    }
                                                    disabled={
                                                      this.state
                                                        .conditionsBuilder
                                                        .conditions.length === 1
                                                    }
                                                  >
                                                    Remove
                                                  </Button>
                                                </Col>
                                              </Row>
                                            )
                                          )}

                                          <Button
                                            variant="outline-primary"
                                            size="sm"
                                            onClick={this.addCondition}
                                          >
                                            Add Condition
                                          </Button>
                                        </div>
                                      </Col>
                                    </Row>

                                    {/* Email Template Configuration */}

                                    <Row className="mb-3">
                                      <Col lg="12">
                                        <Form.Label>
                                          <strong>
                                            Email Template Configuration
                                          </strong>
                                        </Form.Label>

                                        <div
                                          className="border rounded p-3"
                                          style={{ backgroundColor: "#f8f9fa" }}
                                        >
                                          {/* Template Selection */}

                                          <Row className="mb-3">
                                            <Col md={6}>
                                              <Form.Label>
                                                Select Email Template
                                              </Form.Label>

                                              <Form.Select
                                                value={
                                                  this.state
                                                    .selectedEmailTemplate
                                                }
                                                onChange={(e) => {
                                                  this.setState({
                                                    selectedEmailTemplate:
                                                      e.target.value,
                                                  });

                                                  if (e.target.value) {
                                                    this.fetchTemplateVariables(
                                                      e.target.value
                                                    );
                                                  }
                                                }}
                                              >
                                                <option value="">
                                                  Select Template
                                                </option>

                                                {this.state.emailTemplates.map(
                                                  (template) => (
                                                    <option
                                                      key={
                                                        template.emailtemplates_Id
                                                      }
                                                      value={
                                                        template.emailtemplates_Id
                                                      }
                                                    >
                                                      {template.name}
                                                    </option>
                                                  )
                                                )}
                                              </Form.Select>
                                            </Col>
                                          </Row>

                                          {/* Parameter Mappings */}

                                          {this.state.templateVariables.length >
                                            0 && (
                                              <div>
                                                <h6>
                                                  Template Variable Mappings
                                                </h6>

                                                {this.state.parameterMappings.map(
                                                  (mapping, index) => (
                                                    <Row
                                                      key={index}
                                                      className="mb-2 p-2 border rounded"
                                                    >
                                                      <Col md={2}>
                                                        <Form.Label>
                                                          Variable
                                                        </Form.Label>

                                                        <Form.Control
                                                          value={
                                                            mapping.templateVariable
                                                          }
                                                          readOnly
                                                          className="bg-light"
                                                        />
                                                      </Col>

                                                      <Col md={2}>
                                                        <Form.Label>
                                                          Source Type
                                                        </Form.Label>

                                                        <Form.Select
                                                          value={
                                                            mapping.sourceType
                                                          }
                                                          onChange={(e) =>
                                                            this.updateParameterMapping(
                                                              index,
                                                              "sourceType",
                                                              e.target.value
                                                            )
                                                          }
                                                        >
                                                          <option value="current_table">
                                                            Current Table
                                                          </option>

                                                          <option value="lookup_table">
                                                            Lookup Table
                                                          </option>
                                                        </Form.Select>
                                                      </Col>

                                                      {mapping.sourceType ===
                                                        "current_table" ? (
                                                        <Col md={3}>
                                                          <Form.Label>
                                                            Field from{" "}
                                                            {
                                                              this.state
                                                                .table_name
                                                            }
                                                          </Form.Label>

                                                          <Form.Select
                                                            value={
                                                              mapping.sourceField
                                                            }
                                                            onChange={(e) =>
                                                              this.updateParameterMapping(
                                                                index,
                                                                "sourceField",
                                                                e.target.value
                                                              )
                                                            }
                                                          >
                                                            <option value="">
                                                              Select Field
                                                            </option>

                                                            {this.state.tableColumns.map(
                                                              (col) => (
                                                                <option
                                                                  key={col.name}
                                                                  value={col.name}
                                                                >
                                                                  {col.name}
                                                                </option>
                                                              )
                                                            )}
                                                          </Form.Select>
                                                        </Col>
                                                      ) : (
                                                        <>
                                                          <Col md={2}>
                                                            <Form.Label>
                                                              Lookup Table
                                                            </Form.Label>

                                                            <Form.Control
                                                              value={
                                                                mapping.lookupTable
                                                              }
                                                              onChange={(e) =>
                                                                this.updateParameterMapping(
                                                                  index,
                                                                  "lookupTable",
                                                                  e.target.value
                                                                )
                                                              }
                                                              placeholder="e.g., customers"
                                                            />
                                                          </Col>

                                                          <Col md={2}>
                                                            <Form.Label>
                                                              Join Field (Current)
                                                            </Form.Label>

                                                            <Form.Select
                                                              value={
                                                                mapping.lookupJoinField
                                                              }
                                                              onChange={(e) =>
                                                                this.updateParameterMapping(
                                                                  index,
                                                                  "lookupJoinField",
                                                                  e.target.value
                                                                )
                                                              }
                                                            >
                                                              <option value="">
                                                                Select Field
                                                              </option>

                                                              {this.state.tableColumns.map(
                                                                (col) => (
                                                                  <option
                                                                    key={col.name}
                                                                    value={
                                                                      col.name
                                                                    }
                                                                  >
                                                                    {col.name}
                                                                  </option>
                                                                )
                                                              )}
                                                            </Form.Select>
                                                          </Col>

                                                          <Col md={2}>
                                                            <Form.Label>
                                                              Fetch Field (Lookup)
                                                            </Form.Label>

                                                            <Form.Control
                                                              value={
                                                                mapping.lookupFetchField
                                                              }
                                                              onChange={(e) =>
                                                                this.updateParameterMapping(
                                                                  index,
                                                                  "lookupFetchField",
                                                                  e.target.value
                                                                )
                                                              }
                                                              placeholder="e.g., email, name"
                                                            />
                                                          </Col>
                                                        </>
                                                      )}
                                                    </Row>
                                                  )
                                                )}
                                              </div>
                                            )}
                                        </div>
                                      </Col>
                                    </Row>

                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>

                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={
                                      this.Table_rule_triggerssubmitHandler
                                    }
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Save
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}

                      {/*offcanvas is over */}
                    </Col>
                  </Row>

                  <br />

                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}

                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
